<script setup lang="ts">
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/modules/user'
import { watchEffect, getCurrentInstance, reactive, ref } from 'vue'
import common from '@/utils/common'
import { fetchPanMajorbioData } from '@/api/common'
import { useRoute } from 'vue-router'
import Cookies from 'js-cookie'
import contractSureDialog from '@/components/home/contractSureDialog.vue'
import originSureDialog from '@/components/home/originSureDialog.vue'
import { useMyDataStore } from '@/store/modules/data'

// pinia使用
const myDataStore = useMyDataStore()
const { breadcrumbsProject, breadcrumbsTool } = storeToRefs(myDataStore)

const userStore = useUserStore()
const { countObj, contractStr } = storeToRefs(userStore)

// 路由使用
const router = useRouter()
const route = useRoute()

// 数据初始化
let defaultActive = ref('1')
const contractSureDialogRef = ref(null)
const originSureDialogRef = ref(null)
let url = window.location.href

// 区分美吉、桑格
const { VITE_APP_MJ_CLOUD_ORIGIN, VITE_APP_SG_CLOUD_ORIGIN } = import.meta.env

let kfOrigin = ref('')
let cloudOrigin = ref('')

if (common.getWebName() === 'mj') {
  cloudOrigin.value = VITE_APP_MJ_CLOUD_ORIGIN
} else if (common.getWebName() === 'sg') {
  cloudOrigin.value = VITE_APP_SG_CLOUD_ORIGIN
}

if (url.indexOf('/project-center/overview') !== -1) {
  // 概览
  defaultActive.value = '1'
} else if (url.indexOf('/project-center/task') !== -1) {
  // 我的事项
  defaultActive.value = '2'
} else if (url.indexOf('/project-center/contract') !== -1) {
  // 我的合同
  defaultActive.value = '3'
} else if (url.indexOf('/project-center/send-order') !== -1) {
  // 订单列表
  defaultActive.value = '4'
} else if (url.indexOf('/project-center/report/project-overview') !== -1) {
  //  项目总览
  defaultActive.value = '5-1'
} else if (url.indexOf('/project-center/report/task') !== -1) {
  //  任务总览
  defaultActive.value = '5-2'
} else if (url.indexOf('/project-center/report/recycle') !== -1) {
  //  回收站
  defaultActive.value = '5-3'
} else if (url.indexOf('/project-center/report/offline') !== -1) {
  // 线下报告
  defaultActive.value = '5-4'
} else if (url.indexOf('/project-center/tool-task') !== -1) {
  // 我的工具任务
  defaultActive.value = '6'
} else if (url.indexOf('/project-center/data/project-data') !== -1) {
  // 项目数据
  defaultActive.value = '7-1'
} else if (url.indexOf('/project-center/data/tool') !== -1) {
  // 工具数据
  defaultActive.value = '7-2'
} else if (url.indexOf('/project-center/data/origin') !== -1) {
  // 原始数据
  defaultActive.value = '7-3'
} else if (url.indexOf('/project-center/my-favorite') !== -1) {
  // 我的收藏

  defaultActive.value = '8'
}
watchEffect(() => {
  const { meta } = route
  if (meta.activeMenu) {
    defaultActive.value = meta.activeMenu as string
  }
})

console.log('所有消息：', countObj.value)
if (
  countObj.value.noticeCount ||
  countObj.value.projectAllCount ||
  countObj.value.reportCount ||
  countObj.value.originCount
) {
  common.setFaviconWithBadge()
}

const { proxy }: any = getCurrentInstance()

const NODE_ENV = import.meta.env.VITE_APP_ENV

const handleSelect = async (key: string, keyPath: string[]) => {
  console.log('菜单索引', key, keyPath)
  let panMajorbioVisible = Cookies.get('panMajorbioVisible')

  let userInfo = common.getCache('user')
  let account_name = ''
  if (userInfo && JSON.stringify(userInfo) !== '{}') {
    account_name = JSON.parse(userInfo).account_name
    // pinia使用
    const userStore = useUserStore()
    // vip登录逻辑
    !common.getCache('vip-token') && userStore.vipLoginFunc()
  }
  console.log(111, key)
  if (
    !(
      key === '2' ||
      key === '7-3' ||
      key === '1' ||
      key === '5-1' ||
      key === '5-2' ||
      key === '5-3' ||
      key === '6' ||
      key === '7-1' ||
      key === '7-2' ||
      key === '8'
    ) &&
    !common.isInnerUser(account_name) &&
    panMajorbioVisible !== '0'
  ) {
    let visible = await getPanMajorbioData()
    if (visible) {
      //  外部客户会卡控，跳转到中间页
      // router.push({ name: 'MiddlePage' })
      // return false

      // 暂不卡控
      if (originSureDialogRef.value) {
        originSureDialogRef.value.dialogVisible = true
      }
    }
  }
  defaultActive.value = key

  let webPre = `${cloudOrigin.value}/page/`
  let webSrc = '' // 原Vip客户中心页面路径（目前未重构的模块）
  if (key === '1') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg')
    // ) {
    router.push('/project-center/overview')
    // } else {
    //   webSrc = webPre + 'project/overview.html'
    //   window.location.href = webSrc
    // }
  } else if (key === '2') {
    router.push('/project-center/task')
  } else if (key === '3') {
    router.push('/project-center/contract')
  } else if (key === '4') {
    router.push('/project-center/send-order')
  } else if (key === '5-4') {
    router.push('/project-center/report/offline')
  } else if (key === '7-3') {
    router.push('/project-center/data/origin')
  } else if (key === '5-1') {
    router.push('/project-center/report/project-overview')
  } else if (key === '5-2') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg') ||
    //   NODE_ENV === 'staging'
    // ) {
    router.push('/project-center/report/task')
    // } else {
    //   webSrc = webPre + 'task/index.html'
    //   window.location.href = webSrc
    // }
  } else if (key === '5-3') {
    // if (NODE_ENV !== 'production') {
    if (
      NODE_ENV === 'local' ||
      NODE_ENV === 'test' ||
      NODE_ENV === 'production'
    ) {
      router.push('/project-center/report/recycle')
    } else {
      webSrc = webPre + 'recycle/index.html'
      window.location.href = webSrc
    }
  } else if (key === '6') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg') ||
    //   (NODE_ENV === 'staging' && common.getWebName() === 'mj')
    // ) {
    router.push('/project-center/tool-task')
    // } else {
    //   webSrc = webPre + 'task/tool.html'
    //   window.location.href = webSrc
    // }
  } else if (key === '7-1') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg') ||
    //   NODE_ENV === 'staging'
    // ) {
    console.log('面包屑数据', breadcrumbsProject.value.length)
    if (breadcrumbsProject.value.length) {
      router.go(0)
    } else {
      router.push('/project-center/data/project-data')
    }
    // } else {
    //   webSrc = webPre + 'file.html'
    //   window.location.href = webSrc
    // }
  } else if (key === '7-2') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg') ||
    //   NODE_ENV === 'staging'
    // ) {
    console.log('面包屑数据', breadcrumbsTool.value.length)
    if (breadcrumbsTool.value.length) {
      router.go(0)
    } else {
      router.push('/project-center/data/tool-data')
    }
    // } else {
    //   webSrc = webPre + 'file/tool.html'
    //   window.location.href = webSrc
    // }
  } else if (key === '8') {
    // if (
    //   NODE_ENV === 'local' ||
    //   NODE_ENV === 'test' ||
    //   (NODE_ENV === 'production' && common.getWebName() === 'sg')
    // ) {
    router.push('/project-center/my-favorite')
    // } else {
    //   webSrc = webPre + 'favorite/pipeline.html'
    //   window.location.href = webSrc
    // }
  } else {
    router.replace({ path: key })
  }

  if (
    key === '2' ||
    key === '3' ||
    key === '4' ||
    key === '5-4' ||
    key === '7-3'
  ) {
    let contractReadVisible = Cookies.get('contractReadVisible')

    if (contractReadVisible === null || contractReadVisible === undefined) {
      // 第一次加载应用走接口
      getChContractRead()
    } else {
      // 之后都走缓存取值
      if (contractSureDialogRef.value) {
        contractSureDialogRef.value.dialogVisible = contractReadVisible === '0'
      }
    }
  } else {
    if (!common.isInnerUser(account_name)) {
      // 客户账号：未确定下载原始文件，不能使用云平台
      let visible = await getPanMajorbioData()
      if (visible) {
        router.replace({ name: 'MiddlePage' })
        return false
      }
    }
  }
}
const handleOpen = (key: string, keyPath: string[]) => {
  defaultActive.value = key
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

const getChContractRead = () => {
  if (contractStr.value) {
    if (contractSureDialogRef.value) {
      contractSureDialogRef.value.dialogVisible = true
    }
  }
}

// 检查网盘数据是否下载/原始数据未下载
const getPanMajorbioData = () => {
  return new Promise((resolve) => {
    fetchPanMajorbioData({}).then((res: any) => {
      let { code, data } = res
      if (code === 0) {
        let { hasUnconfirmed } = data
        if (hasUnconfirmed) {
          resolve(true)
        } else {
          resolve(false)
        }
      }
    })
  })
}
</script>

<template>
  <!-- 原始数据未确认的弹窗 -->
  <origin-sure-dialog ref="originSureDialogRef" />

  <div
    :class="[
      'siderbar-menu',
      (common.getWebName() === 'sg' || common.getWebName() === 'local') &&
        'sg-siderbar-menu'
    ]"
  >
    <p class="siderbar-title">
      <i></i>
      项目中心
    </p>
    <el-menu
      :default-active="defaultActive"
      @select="handleSelect"
      @open="handleOpen"
      @close="handleClose"
      :default-openeds="['5', '7']"
    >
      <el-menu-item index="1">
        <span><i class="iconkf"></i>概览</span>
      </el-menu-item>
      <el-menu-item index="2">
        <span>
          <i class="iconkf"></i>我的事项
          <el-tag v-if="countObj.noticeCount" type="danger" effect="dark" round>
            {{ countObj.noticeCount }}
          </el-tag>
        </span>
      </el-menu-item>
      <el-menu-item index="3">
        <span><i class="iconkf"></i>我的合同</span>
      </el-menu-item>
      <el-menu-item index="4">
        <span><i class="iconkf"></i>订单列表</span>
      </el-menu-item>
      <el-sub-menu index="5">
        <template #title>
          <span><i class="iconkf"></i>我的分析报告</span>
        </template>
        <el-menu-item index="5-1"
          >项目总览
          <el-tag
            v-if="countObj.projectAllCount"
            type="success"
            effect="dark"
            round
          >
            {{ countObj.projectAllCount }}
          </el-tag>
        </el-menu-item>
        <el-menu-item index="5-2">任务总览</el-menu-item>
        <el-menu-item index="5-3">回收站</el-menu-item>
        <el-menu-item index="5-4"
          >线下报告
          <el-tag v-if="countObj.reportCount" type="danger" effect="dark" round>
            {{ countObj.reportCount }}
          </el-tag></el-menu-item
        >
      </el-sub-menu>
      <el-menu-item index="6" id="btn6">
        <span><i class="iconkf"></i>我的工具任务</span>
      </el-menu-item>
      <el-sub-menu index="7">
        <template #title>
          <span><i class="iconkf"></i>我的数据</span>
        </template>
        <el-menu-item index="7-1">项目数据 </el-menu-item>
        <el-menu-item index="7-2">工具数据</el-menu-item>
        <el-menu-item index="7-3"
          >原始数据
          <el-tag v-if="countObj.originCount" type="danger" effect="dark" round>
            {{ countObj.originCount }}
          </el-tag>
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="8">
        <span><i class="iconkf"></i>我的收藏</span>
      </el-menu-item>
    </el-menu>
  </div>

  <!-- 合同立项信息未确认的弹窗 -->
  <contract-sure-dialog
    :contractStr="contractStr"
    ref="contractSureDialogRef"
  />
</template>

<style lang="scss">
@import '@/styles/layout/siderBar.scss';
</style>
